export const RaffleMiningCrankABI = [
  {
    "inputs": [],
    "stateMutability": "nonpayable",
    "type": "constructor"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "owner",
        "type": "address"
      }
    ],
    "name": "OwnableInvalidOwner",
    "type": "error"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "account",
        "type": "address"
      }
    ],
    "name": "OwnableUnauthorizedAccount",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "ReentrancyGuardReentrantCall",
    "type": "error"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "gasUsed",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "itemsProcessed",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "bool",
        "name": "batchCompleted",
        "type": "bool"
      }
    ],
    "name": "AutoPlayLoopGas",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "totalGasUsed",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "bool",
        "name": "moreWork",
        "type": "bool"
      }
    ],
    "name": "CrankGasUsed",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "address",
        "name": "oldFinalization",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "address",
        "name": "newFinalization",
        "type": "address"
      }
    ],
    "name": "FinalizationContractUpdated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "previousOwner",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "newOwner",
        "type": "address"
      }
    ],
    "name": "OwnershipTransferred",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "gasUsed",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "itemsProcessed",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "bool",
        "name": "batchCompleted",
        "type": "bool"
      }
    ],
    "name": "PendingPlaysLoopGas",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "address",
        "name": "oldStorage",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "address",
        "name": "newStorage",
        "type": "address"
      }
    ],
    "name": "StorageContractUpdated",
    "type": "event"
  },
  {
    "inputs": [],
    "name": "crank",
    "outputs": [
      {
        "internalType": "bool",
        "name": "moreWork",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "finalizationContract",
    "outputs": [
      {
        "internalType": "contract ICrankFinalization",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getPendingWork",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "autoPlaysRemaining",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "pendingPlaysRemaining",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "roundReadyToFinalize",
            "type": "bool"
          },
          {
            "internalType": "uint256",
            "name": "roundToFinalize",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "welephantDistributionsRemaining",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "ethDistributionsRemaining",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "roundBeingDistributed",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "singleWinnerSelectionInProgress",
            "type": "bool"
          },
          {
            "internalType": "uint256",
            "name": "singleWinnerRound",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "currentRoundFinalized",
            "type": "bool"
          },
          {
            "internalType": "uint256",
            "name": "vaultReservesAvailable",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "workAvailable",
            "type": "bool"
          }
        ],
        "internalType": "struct RaffleMiningTypes.PendingWork",
        "name": "work",
        "type": "tuple"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "maxGasPrice",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "maxIterAutoPlay",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "maxIterDistribution",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "maxIterPendingPlay",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "maxIterSingleWinner",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "owner",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "renounceOwnership",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "_finalizationContract",
        "type": "address"
      }
    ],
    "name": "setFinalizationContract",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_maxGasPrice",
        "type": "uint256"
      }
    ],
    "name": "setMaxGasPrice",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_maxIter",
        "type": "uint256"
      }
    ],
    "name": "setMaxIterAutoPlay",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_maxIter",
        "type": "uint256"
      }
    ],
    "name": "setMaxIterDistribution",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_maxIter",
        "type": "uint256"
      }
    ],
    "name": "setMaxIterPendingPlay",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_maxIter",
        "type": "uint256"
      }
    ],
    "name": "setMaxIterSingleWinner",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "_storageContract",
        "type": "address"
      }
    ],
    "name": "setStorageContract",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "storageContract",
    "outputs": [
      {
        "internalType": "contract IRaffleMiningWritableStorage",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "newOwner",
        "type": "address"
      }
    ],
    "name": "transferOwnership",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  }
] as const;
